import React, { ReactElement, useState, ChangeEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  PopUp,
  EditCard,
  StyledIcon,
  StyledInputs,
  StyledInput,
} from '../../styled-components'

/* import { updatePart } from '../../../../api/part'
 */ import { Part } from '../../../../types/training'
import Icon from '../../../icon'
import { Alert } from '../../../../constants/sweet-alert'
import Inputfield from '../../../input/input-field'
import Button from '../../../button'
import Select from '../../../select'
import Text from '../../../text'
import { addPart, updatePart } from '../../../../api/part'

interface PartEditProps {
  part: Part | Omit<Part, 'questions' | 'status' | 'color' | 'text'>
  onClose: () => void
  categoryId?: string
}

const PartAddEdit = ({
  part,
  onClose,
  categoryId,
}: PartEditProps): ReactElement => {
  const selectOptions = [
    { id: 0, value: 'info', label: 'text' },
    { id: 1, value: 'quiz', label: 'quiz' },
  ]

  const [title, setTitle] = useState(part.title)
  const [isWhat, setIsWhat] = useState(part.isWhat || selectOptions[0].value)
  const [placement, setPlacement] = useState(part.placement)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const onEditSave = () => {
    setLoading(true)

    const payload = {
      title,
      placement,
      isWhat,
    }
    updatePart(part.id, payload).then((status) => {
      if (status === 200) {
        setLoading(false)

        Alert.fire({
          icon: 'success',
          title: `Updated`,
        })
        navigate(0)
      } else {
        setLoading(false)

        Alert.fire({
          icon: 'error',
          title: `Error`,
        })
      }
    })
  }

  const onAddSave = () => {
    if (categoryId) {
      setLoading(true)
      const payload = {
        part: {
          title,
          placement,
          isWhat,
          quizType: null,
        },
        categoryId,
      }

      addPart(payload).then((status) => {
        if (status === 201) {
          setLoading(false)
          Alert.fire({
            icon: 'success',
            title: `Created`,
          })
          navigate(0)
        } else {
          setLoading(false)
          Alert.fire({
            icon: 'error',
            title: `Error`,
          })
        }
      })
    }
  }

  return (
    <PopUp>
      <EditCard>
        <StyledIcon onClick={onClose}>
          <Icon name={'cil:x'} color="darkRed" width={20} height={20} />
        </StyledIcon>
        <Inputfield
          value={title}
          labelName="العنوان"
          onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
            setTitle(event.target.value)
          }
          type="text"
        />
        <StyledInputs>
          <StyledInput>
            <Inputfield
              value={placement}
              labelName="الرتبة"
              onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
                setPlacement(parseInt(event.target.value, 10))
              }
              type="number"
            />
          </StyledInput>
          <StyledInput>
            <Text size="small">النوع</Text>
            <Select
              defaultValue={selectOptions.find((e) => e.value === isWhat)}
              onChange={(selectedItem) => {
                setIsWhat(selectedItem.value)
              }}
              options={selectOptions}
            />
          </StyledInput>
        </StyledInputs>
        <Button
          loading={loading}
          onClick={part.id ? onEditSave : onAddSave}
          color="red"
        >
          <Icon name="entypo:check" />
        </Button>
      </EditCard>
    </PopUp>
  )
}

export default PartAddEdit
